/** @graphql cc **/
import gql from 'graphql-tag';

import { getApolloClient } from '@confluence/graphql/entry-points/getApolloClient.ts';

import {
	SitePermissionType,
	type FetchPresenceUsersGuestStatusQuery as UsersQuery$data,
	type FetchPresenceUsersGuestStatusQueryVariables as UsersQuery$variables,
} from './__types__/FetchPresenceUsersGuestStatusQuery.ts';

export const fetchPresenceUsersGuestStatus = (accountIds: string[]) => {
	// eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
	return getApolloClient()
		.query<UsersQuery$data, UsersQuery$variables>({
			query: gql`
				query fetchPresenceUsersGuestStatusQuery($accountIds: [String]) {
					confluenceUsers(accountIds: $accountIds) {
						nodes {
							... on KnownUser {
								accountId
							}
							... on UnknownUser {
								accountId
							}
							permissionType
						}
					}
				}
			`,
			variables: { accountIds },
		})
		.then(({ data }) => {
			return (
				data?.confluenceUsers?.nodes
					?.filter((user: any) => user?.accountId)
					.map((user: any) => ({
						userId: user?.accountId ?? '',
						// @ts-expect-error - TS2869 Typescript 5.9.2 upgrade
						isGuest: user?.permissionType === SitePermissionType.EXTERNAL ?? undefined,
					})) ?? []
			);
		});
};
